import { I10DIABOUCECS_State } from '@batical/types/src'

const I10DIABOUCECS: I10DIABOUCECS_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  coeffMajoration: 'ecs1',
  in_tempEauFroide: 10.0,
  in_tempBouclage: 55.0,
  in_evier: 0.0,
  in_lavabo: 0.0,
  in_bidet: 0.0,
  in_baignoire: 0.0,
  in_douche: 0.0,
  in_robinetdemi: 0.0,
  in_robinetquart: 0.0,
  in_lavemain: 0.0,
  in_baclaver: 0.0,
  in_linge: 0.0,
  in_vaiselle: 0.0,
  tube_uuid: '3950E368-DDA7-451A-A349-F3A5B13B5452',
  canalisationdebit_uuid: 'cnn3',
  res_somme_debit: 0.0,
  res_coeff_simul: 0.0,
  res_debit_probable: 0.0,
  res_diam_int_probable: 0.0,
  res_vitesse_sil_max: 0.0,
  res_debit_max_prob: 0.0,
  res_vitesse_debit_maxi: 0.0,
  res_diamConforme: '',
  mode: 'none',
  calcul_code: 'I10DIABOUCECS'
}

export default I10DIABOUCECS
